export const dialogs = {
	NO_SUBORDINATE_TO_HANDOVER: 'NO_SUBORDINATE_TO_HANDOVER',
};
